import { SET_PAGINATION } from "../storeTypes";

export const setPagination = (payload) => {
    return {
        type: SET_PAGINATION,
        payload
    }
};
